<script>
    import FileUpload from '../../course/FileUpload';
    import FilesUpload from '../../course/FilesUpload';
    import {Form} from '../../../helpers/Form/Form'
    import * as VueGoogleMaps from 'vue2-google-maps';
    import { VueTelInput } from 'vue-tel-input'

    export default {
        name: "Profile",
        components: {
            'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
            'file-upload': FileUpload,
            'files-upload': FilesUpload,
            VueTelInput,
        },
        props: {
            companyprop: {},
            user: {},
        },
        data() {
            return {
                message: null,
                legalForms: [],
                typologies: [],
                federations: [],
                bodies: [],
                types: ['geocode'],
                imageMaxSize: 3, // megabyte
                form: null,
                fetch: new Form({})
            }
        },
        computed: {
            companyHasPrivacyPolicyFile() {
                if (this.form.privacyPolicyFile instanceof File) {
                    return true
                }
                return !_.isEmpty(this.form.privacy_policy_path) && this.form.privacy_policy_path != 'null'
            },
            companyHasStatuteFile() {
                if (this.form.statuteFile instanceof File) {
                    return true
                }
                return !_.isEmpty(this.form.statute_path) && this.form.statute_path != 'null'
            }
        },
        mounted() {
            var self = this;

            this.message = null;
            this.getCompany()

            this.$bus.$on('contracts_accepted', () => {
                this.form.accept_payments = true;
                this.form.contract_1 = true;
                this.form.contract_2 = true;
                this.form.contract_3 = true;
            });

            this.$bus.$on('contracts_reaccepted', () => {
                this.form.accept_payments = true;
            });
        },
        methods: {
            getCompany() {
                this.fetch
                    .get(route('companies.detail', this.companyprop))
                    .then(response => {
                        this.$set(this, 'form', new Form(Object.assign(response.company, {
                            logo: null,
                            gallery: [],
                            statutefile: null,
                            privacyPolicyFile: null,
                            addressComponents: [],
                            updatedLogo: 0
                        })))

                        this.getFederations();
                        this.getBodies();
                        this.getTypologies();
                        this.getLegalForms();
                        this.initCompany();                        
                    })
            },
            openContractsModal() {
                this.$bus.$emit('contracts-modal.show', {form: this.form})
                $('#contracts_modal').modal({backdrop: 'static', keyboard: false});
            },
            acceptPaymentContracts() {
                var self = this;

                if (!this.form.contract_1 &&
                    !this.form.contract_2 &&
                    !this.form.contract_3) {
                    this.openContractsModal();
                } else {
                    this.form
                        .submit('post', '/companies/contracts')
                        .then((response) => {
                            this.$bus.$emit('contracts_reaccepted')
                            window.toastr.success("Impostazioni salvate correttamente");
                            $('#contracts_modal').modal('hide')
                        }).catch((error) => {
                            this.message = 'Error';
                        });
                }
            },
            initCompany() {
                if (this.form && this.form.gallery_images) {
                    this.form.gallery = this.form.gallery_images.map((image) => {
                        return image.file_path;
                    });
                }
            },
            togglePayments() {
                if (this.form.accept_payments) {
                    $("#disabled-alert-contracts_modal").modal('show')
                } else {
                    // this.openContractsModal()
                    $("#enabled-alert-contracts_modal").modal('show')
                }
            },
            discardPaymentContracts() {
                this.form
                    .submit('post', route('contacts.decline'))
                    .then((response) => {
                        this.form.accept_payments = false;
                        window.toastr.success("Impostazioni salvate correttamente");
                        $('#contracts_modal').modal('hide')
                    }).catch((error) => {
                        this.message = 'Error'
                    });
            },
            getFederations() {
                axios({
                    method: 'get',
                    url: '/federations'
                }).then((response) => {
                    this.federations = response.data.federations;

                }).catch((error) => {
                    this.$emit('init-error', 'Could not load federations');
                });
            },
            getBodies() {
                axios({
                    method: 'get',
                    url: '/bodies'
                }).then((response) => {
                    this.bodies = response.data.bodies;

                }).catch((error) => {
                    this.$emit('init-error', 'Could not load bodies');
                });
            },
            getTypologies() {
                axios({
                    method: 'get',
                    url: '/typologies'
                }).then((response) => {
                    this.typologies = response.data.typologies;

                }).catch((error) => {
                    this.$emit('init-error', 'Could not load typologies');
                });
            }
            ,
            getLegalForms() {
                axios({
                    method: 'get',
                    url: '/legal-forms'
                }).then((response) => {
                    this.legalForms = response.data.legalForms;

                }).catch((error) => {
                    this.$emit('init-error', 'Could not load legal forms');
                });
            },
            removeStatuteFile() {
                this.form.setData('statute_path', '')
                this.form.setData('statuteFile', null)

                window.toastr.success("Statuto rimosso");
            },
            removePrivacyFile() {
                this.form.setData('privacy_policy_path', '')
                this.form.setData('privacyPolicyFile', null)

                window.toastr.success("Privacy rimossa");
            },
            postForm() {
                this.message = null;

                let formData = new FormData();
                if (this.form.logo instanceof File) {
                    formData.append('logo', this.form.logo);
                }
                if (this.form.statuteFile instanceof File) {
                    formData.append('statute-file', this.form.statuteFile);
                }
                if (this.form.privacyPolicyFile instanceof File) {
                    formData.append('privacy-policy-file', this.form.privacyPolicyFile);
                }

                let form = _.omit(this.form.data(), ['logo', 'statuteFile', 'privacyPolicyFile', 'courses'])
                for (let key in form) {
                    if (key !== 'addressComponents' && form[key] !== null) {
                        formData.append(key, form[key]);
                    }
                }

                for (let key in this.form.addressComponents) {
                    formData.append('addressComponents[' + key + ']', this.form.addressComponents[key]);
                    for (let key2 in this.form.addressComponents[key]) {
                        formData.append('addressComponents[' + key + '][' + key2 + ']', this.form.addressComponents[key][key2]);
                    }
                }

                formData.append('_method', 'PUT');

                if (this.form.gallery.length > 0) {
                    this.form.gallery.forEach((item, index) => {
                        formData.append('gallery[' + index + ']', item);
                    });
                }

                this.form
                    .submitWith('post', `/companies/${this.companyprop}`, formData)
                    .then((response) => {
                        window.toastr.success("Profilo salvato correttamente");
                    }).catch((error) => {
                        if (error.hasOwnProperty('response')) {
                            if (error.response.status === 422) {
                                this.$emit('init-error', 'Impossibile validare il form');
                            } else {
                                this.$emit('init-error', 'Internal server error');
                            }
                        } else  {
                            this.$emit('init-error', 'Impossibile validare il form');
                        }

                        $("html,body").animate({scrollTop: $(".is-invalid").first().offset().top - 20})
                    });
            },
            getAddressData(payload) {
                this.form.address = payload.formatted_address;
                this.form.addressComponents = payload.address_components;
                this.form.latitude = payload.geometry.location.lat();
                this.form.longitude = payload.geometry.location.lng();
            },
            onFile(file) {
                this.form.logo = file;
                this.form.logo_path = '';
            },
            onSizeExceeded(size) {
                // this.message = 'Image ${size}Mb size exceeds limits of ${this.imageMaxSize}Mb!';
            },
            onFileGallery(file) {
                this.form.gallery.push(file);
            },
            removeFileGallery(index) {
                this.form.gallery.splice(index, 1);
            },
            removeStoredFileGallery(index) {
                let image = this.form.gallery_images[index]
                this.fetch.submit('delete', route('companies.delete_gallery_image', image.id))
            },
            onStatuteFileChange(e) {
                const files = e.target.files || e.dataTransfer.files;

                if (!files.length) {
                    return;
                }
                this.$set(this.form, 'statuteFile', files[0])

                window.toastr.success("Hai inserito un nuovo Statuto - Salva");
            }
            ,
            onPrivacyPolicyFileChange(e) {
                const files = e.target.files || e.dataTransfer.files;

                if (!files.length) {
                    return;
                }
                this.$set(this.form, 'privacyPolicyFile', files[0])

                window.toastr.success("Hai inserito una nuova Privacy Policy - Salva");
            },
            validateIban() {
                if (this.form.iban && this.form.iban !== '' && this.form.iban !== 'null') {
                    let pass = false;
                    let iban = this.form.iban.replace(/\s/g, '');
                    iban = iban.toLowerCase();
                    let countries = {
                        'al': 28, 'ad': 24, 'at': 20, 'az': 28, 'bh': 22, 'be': 16, 'ba': 20, 'br': 29, 'bg': 22, 'cr': 21, 'hr': 21, 'cy': 28, 'cz': 24, 'dk': 18, 'do': 28, 'ee': 20, 'fo': 18, 'fi': 18, 'fr': 27, 'ge': 22, 'de': 22, 'gi': 23, 'gr': 27, 'gl': 18, 'gt': 28, 'hu': 28, 'is': 26, 'ie': 22, 'il': 23, 'it': 27, 'jo': 30, 'kz': 20, 'kw': 30, 'lv': 21, 'lb': 28, 'li': 21, 'lt': 20, 'lu': 20, 'mk': 19, 'mt': 31, 'mr': 27, 'mu': 30, 'mc': 27, 'md': 24, 'me': 22, 'nl': 18, 'no': 15, 'pk': 24, 'ps': 29, 'pl': 28, 'pt': 25, 'qa': 29, 'ro': 24, 'sm': 27, 'sa': 24, 'rs': 22, 'sk': 24, 'si': 19, 'es': 24, 'se': 24, 'ch': 21, 'tn': 24, 'tr': 26, 'ae': 23, 'gb': 22, 'vg': 24
                    };
                    let chars = {
                        'a': 10, 'b': 11, 'c': 12, 'd': 13, 'e': 14, 'f': 15, 'g': 16, 'h': 17, 'i': 18, 'j': 19, 'k': 20, 'l': 21, 'm': 22, 'n': 23, 'o': 24, 'p': 25, 'q': 26, 'r': 27, 's': 28, 't': 29, 'u': 30, 'v': 31, 'w': 32, 'x': 33, 'y': 34, 'z': 35
                    };

                    if (iban.length == countries[iban.substring(0, 2)]) {

                        let MovedChar = iban.substring(4);
                        MovedChar += iban.substring(0, 4);

                        let MovedCharArray = MovedChar.split('');

                        let ibanCheck = "";

                        MovedCharArray.forEach((value) => {
                            if (isNaN(value)) {
                                value = chars[value];
                            }
                            ibanCheck += value.toString();
                        });


                        let cRest = "";
                        let cChar = "";
                        let cOperator = "";
                        let p = 0;
                        for (p = 0; p < ibanCheck.length; p++) {
                            cChar = ibanCheck.charAt(p);
                            cOperator = "" + cRest + "" + cChar;
                            cRest = cOperator % 97;
                        }

                        if (cRest === 1) {
                            pass = true;
                        }
                        else {
                            pass = false;
                        }
                    }
                    else {
                        pass = false;
                    }
                    return pass;
                } else {
                    return true;
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Profile.vue